import React from 'react'


import './ShowGeneral.css'

export default function CarouserCard({url , sku , price , pricepromo , ccomment , titlesp , show }) {

  function getDecimals( n )
  {
    var p = n.toString() ;


    //console.log( p ) ;

    var v = p.indexOf(".") ;

    p = p.substring( 0 , v + 3 )

    if ( v > 3 )
    {
      //1999.00

      var index = 2 ;

      if ( p.length === 7 )
      {
        index = 1 
      }

      p = insertAtIndex( p , "," , index )
    }

    return  p ;

  }

  function setComma( p )
  {
    p = p + ".00";

    //console.log( p ) ;


    var v = p.indexOf(".") ;

    p = p.substring( 0 , v + 3 )

    if ( v > 3 )
    {
      //1999.00

      var index = 2 ;

      if ( p.length === 7 )
      {
        index = 1 
      }

      p = insertAtIndex( p , "," , index )
    }

    return p ;

  }

  function insertAtIndex(str, substring, index) {
    return str.slice(0, index) + substring + str.slice(index);
  }

  function onClick(e)
  {
    //e.preventDefault() ;

    console.log( "Se le dio click a la imagen " + sku ) ;

    show( { status : true ,
            url ,
            sku : sku ,
            price ,
            pricepromo ,
            titlesp 
          } ) ;
  }

  return (
    <div className='px-5' >

          <div className='d-flex justify-content-around ' style={{borderWidth:'2',borderColor:'grey', 
         borderRadius:'5px' , borderStyle:'solid' }} >
            <div className='w100 pt-5 '>
              <p className='pt-5' style={{fontStyle:'italic'}}>{sku} </p>
              <p>Price ={"$"+getDecimals(price)} </p>
              <p>Promo={"$"+ setComma( pricepromo ) }</p>
              <p>{titlesp}</p>

              <div class="tooltip2" onClick={onClick}>Mas Información
                <span class="tooltiptext">Da Click en imagen para mas detalles</span>
              </div>

            </div>
            <div className='w100  align-content-center' >
              <img src={url} onClick={onClick}  alt='' height='400px' style={{backgroundColor:'grey' , cursor:'grab'}}></img>
            </div>
          </div>
        

            
        
    </div>
  )
}
